import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent, QuoteHolder} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const options = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['Community builder', 'Founder', 'VC/Investor']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of total response, by population type'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: 'The rise of China',
      data: [11, 12, 18]
  }, {
      name: 'Growth in frontier tech',
      data: [11, 18, 24]
  }, {
      name: 'International trade',
      data: [22, 6, 6]
    }, {
        name: 'Regional tech conferences',
        data: [22, 12, 6]
      }, {
          name: 'Others',
          data: [33, 38, 47]



  }]
}




export class ChapterTwentyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}


        </Subtopic>

        <TextHolder text="Globally, the tech startup sector proved to be exciting, with many developments impacting SEA. Uber’s decision to sharpen its focus on its key markets, for example, led to its exit from SEA, leaving its rival Grab to “grab” the ride-sharing business. Regional startups proved just as capable of raising multi-billion dollar funding rounds as their overseas counterparts." />



                <div className="block-outer block-outer-tableholder">
                  <div className="block-inner block-inner-tableholder">
                    <table id="t01">
                    <tbody>
                    <tr>
                      <th>These highlights demonstrate that there was a thriving startup ecosystem in SEA over the last 12 months. In addition: </th>

                    </tr>
                      <tr>
                        <td>
                        {'Singapore-based '} <a href="https://www.channelnewsasia.com/news/business/grab-attracts-s-2-7b-in-investments-from-didi-chuxing-softbank-9057314">Grab </a>{' raised the largest funding round in SEA history mid-last year: ($2 billion from Didi Chuxing and Softbank).'}</td>

                      </tr>
                      <tr>
                        <td>
                        {'In the same month, Indonesian e-commerce firm '}<a href="https://asia.nikkei.com/Business/Indonesia-s-Tokopedia-gets-top-investment-from-Alibaba">Tokopedia </a>{'raised $1.1 billion'}
                        </td>
                      </tr>

                      <tr>
                        <td>
                        {'E-gaming firm '}<a href="https://www.dealstreetasia.com/stories/future-nyse-listed-sea-ltd-acquires-82-vietnams-foody-64m-83084/">Sea </a>{'bought 82% of Vietnamese media platform Foody in September.'}
                        </td>
                      </tr>

                      <tr>
                        <td>
                      <a href="https://techcrunch.com/2017/11/19/acommerce-lands-65m/">aCommerce, </a>{'based in Thailand, raised $65 million in November from KKR-backed Emerald Media.'}
                        </td>
                      </tr>

                      <tr>
                        <td>
                        {'In December, e-commerce giant Amazon rolled out '}<a href="https://techcrunch.com/2017/07/25/amazon-singapore-launch/">Amazon Prime </a>{'in Singapore'}
                        </td>
                      </tr>

                      <tr>
                        <td>
                        {'Indonesian e-commerce platform '}<a href="http://www.thejakartapost.com/life/2018/01/11/bukalapak-officially-becomes-indonesias-fourth-unicorn-startup.html">Bukalapak </a>{'was valued at over $1 billion in January, becoming SEA’s seventh unicorn.'}
                        </td>
                      </tr>

                      <tr>
                        <td>
                        {'In the same month, Alibaba rival JD.com invested in a Series C investment round with Vietnam-based online retail service '}<a href="https://www.reuters.com/article/us-jd-com-tiki-vn-funding/jd-com-widens-southeast-asia-presence-by-investing-in-vietnams-tiki-vn-idUSKBN1F5075">Tiki  </a>{'Although the round was undisclosed, it was estimated by TechCrunch to be around $50 million.'}
                        </td>
                      </tr>
                      <tr>
                        <td>
                        {'In February, Indonesian ride-hailing firm '}<a href="https://uk.reuters.com/article/uk-go-jek-fundraising/indonesias-go-jek-raises-1-5-billion-as-ride-hailing-market-heats-up-sources-idUKKCN1GA156">Go-Jek </a>{'raised $1.5 billion to expand in Vietnam, Thailand, Singapore and the Philippines.'}
                        </td>
                      </tr>
                      <tr>
                        <td>
                      <a href="https://www.straitstimes.com/business/companies-markets/grab-buys-ubers-south-east-asia-business-uber-gets-275-stake-in-grab">Grab  </a>{'acquired Uber Southeast Asia in March.'}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                </div>
                </div>




          <Highchartscomponent  chartsText="Which tech ecosystem and/or geopolitical event(s) had the greatest impact on the region in the past 12 months?" chartsBottomText="Below are some of the respondents’ perspectives about developments over the past 12 months that were collected during one-on-one interviews. Their comments have been lightly edited for clarity and brevity." options={options} source="Source: 2018 State of SE Asian Tech Survey" />

          <QuoteHolder quote="There were a few major pieces of news last year which were generally good for the SEA startup ecosystem. First was Alibaba's acquisition of Lazada which proved the genuine availability of exits for ASEAN-based startups on a large scale to the market. The second would be Grab's acquisition of Uber's operations in the region which showed the market the genuine opportunity for ASEAN based startups to compete and surpass Western based startups. Both events, I believe, showcased the strength of the startup ecosystem in ASEAN and will hopefully increase foreign investor's confidence in ASEAN." authorName="Naysan Munusamy" authorTitle="Co-founder of Moneymatch"/>


          <div className="block-outer block-outer-quoteholder quote-color-light">
            <div className="block-inner block-inner-quoteholder">
              <div className="quote-holder">
              <div className="quotation"><i className="fas fa-quote-right fa-3x"></i></div>

                <p>I feel the most exciting news for the SEA tech ecosystem in 2017/2018 was Grabs acquisition of Uber in SEA, because it does show that homegrown startups from SEA can become successful and win a competitive fight against a very strong and well-funded US counterpart.</p>
                <div className="quotation" style={{textAlign: 'right'}}><i className="fas fa-quote-right fa-3x" ></i></div>
              </div>
              <div className="authorName-holder">
                <p>Jonathan Eg</p>
              </div>
              <div className="authorTitle-holder">
                <p>Founder and CEO of Partipost</p>
              </div>
            </div>
          </div>





          <QuoteHolder quote="In 2017, I saw more and more excitement from startups that started looking overseas. The case of local companies expanding abroad like Go-Jek is definitely helping push the ecosystem and is a good example. I think we will see more and more cases following the 'Big Brother' footstep." authorName="Casper Sermsuksan" authorTitle="Co-founder of Kulina "/>

          <div className="block-outer block-outer-quoteholder quote-color-light">
            <div className="block-inner block-inner-quoteholder">
              <div className="quote-holder">
              <div className="quotation"><i className="fas fa-quote-right fa-3x"></i></div>

                <p>For me, the growth of the e-commerce platforms like Lazada, Shopee and local players like 11street and Mudah was very positive news for the SEA region from the past 12 months—end consumers always reap the most benefit. The introduction of e-wallets was also very exciting! Another notable success was definitely Grab and its horizontal and vertical expansions.</p>
                <div className="quotation" style={{textAlign: 'right'}}><i className="fas fa-quote-right fa-3x" ></i></div>
              </div>
              <div className="authorName-holder">
                <p>Nadia Jalil</p>
              </div>
              <div className="authorTitle-holder">
                <p>Founder and CEO of MyBump Media</p>
              </div>
            </div>
          </div>

          <QuoteHolder quote="On the surface, it's sad to say that Uber leaving SEA was the most exciting news for SEA Tech ecosystem in 2017. It's a proof that SEA is a large and growing market, becoming the new hot spot in world wide tech scene. It's a proof that SEA can develop its own multi-national company with the same level of competition as other regions in the world. It's also a proof that SEA becoming more and more united place where businesses can grow across borders. And finally, it brings inclusive services to underserved people." authorName="SyPhong Bui" authorTitle="Founder and CEO of OnOnpay"/>



          <div className="block-outer block-outer-quoteholder quote-color-light">
            <div className="block-inner block-inner-quoteholder">
              <div className="quote-holder">
              <div className="quotation"><i className="fas fa-quote-right fa-3x"></i></div>

                <p>The successful IPOs of companies like Sea Group and Razer was the most exciting news from 2017, in my view, because it showed the potential of building a company from SEA that can scale globally at unicorn valuations. This will bring more talent, investors and founders to join the SEA tech ecosystem.</p>
                <div className="quotation" style={{textAlign: 'right'}}><i className="fas fa-quote-right fa-3x" ></i></div>
              </div>
              <div className="authorName-holder">
                <p>Nidhi Gupta</p>
              </div>
              <div className="authorTitle-holder">
                <p>Co-founder and CEO of Portcast</p>
              </div>
            </div>
          </div>

          <QuoteHolder quote="I believe Grab acquiring Uber, Go-Jek, and the Digital Free Trade Zone in Malaysia would be some of the bigger news this year in the region, putting SEA on the map as bullish market for tech. More and more tech experts are looking towards this region now." authorName="Jonathan Oh" authorTitle="Founder and CEO, Supplycart"/>


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/21.js